import { render, staticRenderFns } from "./headPageNew.vue?vue&type=template&id=a32adf7c&scoped=true"
import script from "./headPageNew.vue?vue&type=script&lang=js"
export * from "./headPageNew.vue?vue&type=script&lang=js"
import style0 from "./headPageNew.vue?vue&type=style&index=0&id=a32adf7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32adf7c",
  null
  
)

export default component.exports